import {useEffect, useState} from 'react';
import queryString from 'query-string-es5';
import {FormattedMessage} from 'react-intl';
import {Card, Col} from '@resurs/tron-react';
import '../../styles/general-styles.css';

const ConfirmContainer = () => {
  const [cwaFlow, setCwaFlow] = useState(null);

  // Make sure all suffixes are UNIQUE
  const allowedHostnameSuffixes = [
    'resursbank.se',
    'resursbank.dk',
    'resursbank.fi',
    'resursbank.no',
    'resurs.com',
    'monthio.com',
  ];

  /**
   * Check if provided hostname match our whitelist
   * @param {string} hostname
   * @returns {boolean}
   */
  function isAllowedHostname(hostname) {
    // Convert the set `hostnameSuffixes` into an array
    // walk the array finding a suffix that match
    return allowedHostnameSuffixes.some((suffix) => hostname.endsWith(suffix));
  }

  useEffect(() => {
    const queryParameters = queryString.parse(window.location.search);

    try {
      const cwaFlowUrl = new URL(queryParameters?.cwa_flow);
      if (
        ['http:', 'https:'].includes(cwaFlowUrl.protocol) &&
        isAllowedHostname(cwaFlowUrl.hostname)
      ) {
        setCwaFlow(cwaFlowUrl);
      } else {
        throw new Error('Invalid URL for query parameter "cwa_flow"!');
      }
    } catch (e) {
      // redirect to error view
      setCwaFlow('/error');
    }
  }, []);

  return (
    <div className="container container--fixed pt-50">
      <Card className="h-100 border-0 mx-auto max-w-800 rounded-0 align-items-center">
        <h4 className="header-font ml-3">
          <FormattedMessage
            id="ConfirmContainer.pageHeader"
            defaultMessage="Du bliver nu dirigeret videre fra Resurs"
          />
        </h4>
        <span className="ml-3">
          <FormattedMessage
            id="ConfirmContainer.pageSubHeader"
            defaultMessage="Du bliver nu dirigeret videre fra Resurs for at indhente information om din økonomi."
          />
        </span>
        <Card className="h-100 border-0 rounded-0">
          <Col sm="12" className="h-100">
            <div className="h-100">
              <div className="d-flex mt-3">
                <div>
                  <a
                    href={cwaFlow}
                    block
                    style={{background: '#005050', color: 'white'}}
                    className="px-5 py-2 my-4 bold-font">
                    <FormattedMessage
                      id="ConfirmContainer.confirmButton"
                      defaultMessage="Fortsæt"
                    />
                  </a>
                </div>
              </div>
            </div>
          </Col>
        </Card>
      </Card>
    </div>
  );
};

export default ConfirmContainer;
